<template>
    <div v-if="courses.length > 0">
        <div v-for="(item, cindex) in courses" :key="cindex">
            <div class="col-xs-12 override-padding">
                <div class="crm_admin_heading course_header courses_heading_0 text-align-center show_icon" :ref="'show_icon_'+cindex" @click="getCourseModuleInfo(item.lmsUserId, item.lmsCourseId, 'course_user_results_modules_' + cindex, cindex)">V</div>
                <div class="crm_admin_heading course_header courses_heading_0 text-align-center hide_icon" :ref="'hide_icon_'+cindex" @click="hideCourseModuleInfo(item.lmsUserId, item.lmsCourseId, 'course_user_results_modules_' + cindex, cindex)">^</div>
                <div class="crm_admin_heading course_header courses_heading_1 text-align-left" v-b-tooltip.hover :title="item.lms_course_title">{{ formatCourseName(item.lms_course_title)  }}</div>
                <div class="crm_admin_heading course_header courses_heading_2 text-align-center">
                  <span v-if="item.timeSpent != 'N/A'">{{ item.timeSpent }}</span>
                  <span v-else>&nbsp;</span>
                </div>
                <div class="crm_admin_heading course_header courses_heading_2 text-align-center">
                    <span v-if="item.completed"><i class="fa fa-check"></i></span>
                    <span v-else>&nbsp;</span>
                </div>
                <div class="crm_admin_heading course_header courses_heading_2 text-align-center">
                    <span v-if="item.score != 'N/A'">{{ item.score }}%</span>
                    <span v-else>&nbsp;</span>
                </div>
                <div class="crm_admin_heading course_header courses_heading_3 text-align-left">&nbsp;&nbsp;</div>
                <div class="crm_admin_heading course_header courses_heading_4 text-align-left">
                    <span v-if="item.completedOn != 'N/A'">{{ item.completedOn }}</span>
                    <span v-else>&nbsp;</span>
                </div>
                <div class="crm_admin_heading course_header courses_heading_5 text-align-left">
                  <a v-if="item.download_link" :href="item.download_link" target="_blank" class="download_cert_link">Download Certificate</a>
                  <span v-else>&nbsp;</span>
                </div>
            </div>

            <!-- modules start -->
            <CourseUserResultsModules
                :ref="'course_user_results_modules_' + cindex"
            >
            </CourseUserResultsModules>
            <!-- modules end -->

        </div>
    </div>
    <div v-else>
        <div class="col-xs-12 override-padding">
          <div class="no_course_header">{{ course_msg }}</div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import CourseUserResultsModules from './course_user_results_modules.vue';
export default {
    data(){
        return{
          courses: [],
          courses_modules: [],
          showModule: false,
          showIcon: [],
          course_msg: '',
        }
    },
    components: {
        CourseUserResultsModules,
    },
    methods: {
        getCourses(menteeId, courseIds) {
            this.course_msg = 'Loading...';
            axios('/account-lookup/user/course-user-results-lists',
            {
              method: 'POST',
              data: {
                user_id: menteeId,
                course_id: courseIds,
              }
            }
            )
            .then(response => {
                this.courses = response.data; 
                for (var i = 0; i < this.courses.length; i++) {
                  this.showIcon['show_icon_'+i] = false;
                }
                if (this.courses.length == 0) {
                  this.course_msg = 'No course is completed';
                }
            })
            .catch(error => {

            });
        },
        getCourseModuleInfo(userId, courseId, elementName, index) {
            //remove
            this.$refs['show_icon_' + index][0].classList.remove('show_icon');
            this.$refs['hide_icon_' + index][0].classList.remove('hide_icon')

            //add
            this.$refs['show_icon_' + index][0].classList.add('hide_icon');
            this.$refs['hide_icon_' + index][0].classList.add('show_icon');
            
            // console.log(elementName)
            // console.log(this.$refs[elementName][0])
            this.$refs[elementName][0].getModules(userId, courseId, true);
        },
        hideCourseModuleInfo(userId, courseId, elementName, index) {
            //remove
            this.$refs['show_icon_' + index][0].classList.remove('hide_icon');
            this.$refs['hide_icon_' + index][0].classList.remove('show_icon')

            //add
            this.$refs['show_icon_' + index][0].classList.add('show_icon');
            this.$refs['hide_icon_' + index][0].classList.add('hide_icon');
            
            this.$refs[elementName][0].getModules(userId, courseId, false);
        },
        formatCourseName(name) {
          if (name.length > 40) {
            return name.substring(0,40)+"..";
          } else {
            return name;
          }
        },
    },
}
</script>
<style scoped>
/* Courses css start */
.courses_heading_0 {
  width: 5%;
  font-weight: 900;
}
.courses_heading_1 {
  width: 30%;
}
.courses_heading_2 {
  width: 10%;
}
.courses_heading_3 {
  width: 8%;
}
.courses_heading_4 {
  width: 12%;
}
.courses_heading_5 {
  width: 15%;
}
.course_header {
  background: #707070 none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #fff;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
}
.courses_content_1 {
  width: 31.66%;
}
.courses_content_2 {
  width: 6%;
}
.courses_content_3 {
  width: 15%;
}
.courses_content_4 {
  width: 7%;
}
.courses_content_5 {
  width: 11%;
}
.courses_content_6 {
  width: 7%;
}
.courses_content_7 {
  width: 22%;
}
.courses_row {
  border-bottom: 1px solid #00ACEE;
  padding: 5px 0px;
}
.courses_hr {
  margin: 30px 0px;
  border-bottom: 2px solid #00ACEE;
}
@media (max-width: 768px) {
  .course_header {
    padding: 8px 1px;
    font-size: 11px;
  }
}
.download_cert_link, .download_cert_link:hover, .download_cert_link:active, .download_cert_link:focus{
  color: #FFF !important;
}
.show_icon { 
  display: show;
}
.hide_icon { 
  display: none;
}
.no_course_header {
  background: #FFFFFF none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #FF0000;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}
/* Courses css end */
</style>


// WEBPACK FOOTER //
// src/components/admin/course_user_results_header.vue